  import * as yup from "yup";

  export interface IApplicationGroup {
    application_Name: string
  }

  export const schema = yup.object({
    application_Name: yup.string().required("Application Name is required"),
  });

  export const emptyTicketGroup: any = {
    application_Name: "",

  }
